import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "dropdown-button__dropdown"
}
const _hoisted_3 = ["disabled", "onClick"]

import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { computed, nextTick, onBeforeUnmount, onMounted, ref, useId, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownButton',
  props: {
    options: {},
    disabled: { type: Boolean },
    style: { default: 'primary' },
    size: { default: 'md' }
  },
  emits: ["clickOption"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "cfb0a770": (`${dropdownWidth.value}px`),
  "5b31b3d2": (`${dropdownTop.value}px`)
}))

const t = i18n.t;

const props = __props;
const emits = __emit;

const domId = useId();
const containerRef = ref<HTMLElement | null>(null);
const displayDropdown = ref(false);
const dropdownTop = ref(0);
const dropdownWidth = ref(0);

const buttonId = computed(() => `dropdown-button-${domId}`);

const customClass = computed(() => `dropdown-button__button--${props.style} dropdown-button__button--${props.size}`);

/**
 * ドロップダウン表示切り替え
 */
const toggleDropdown = () => {
  displayDropdown.value = !displayDropdown.value;
};

/**
 * ドロップダウンを計算
 */
const calcDropdown = async () => {
  await nextTick();
  const button = document.getElementById(buttonId.value);
  if (!button) {
    dropdownWidth.value = 0;
    return;
  }
  dropdownTop.value = button.offsetTop + button.clientHeight;
  if (props.style === 'secondary') dropdownTop.value += 2;
  dropdownWidth.value = button.clientWidth;
};

/**
 * ドロップダウンを閉じる
 * @param event - クリックイベント
 */
const closeDropdown = (event: Event) => {
  if (!displayDropdown.value) return;
  const container = containerRef.value;
  if (container && event.composedPath().includes(container)) return;

  displayDropdown.value = false;
};

/**
 * 選択肢をクリックした際の処理
 * @param value - クリックした選択肢の値
 */
const onClickOptions = (value: string) => {
  displayDropdown.value = false;
  emits('clickOption', value);
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdown);
});

watch(
  () => displayDropdown.value,
  async (v) => {
    if (v) await calcDropdown();
  },
  { immediate: true }
);

watch(
  () => i18n.locale,
  async () => {
    await calcDropdown();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "dropdown-button"
  }, [
    _createElementVNode("button", {
      id: buttonId.value,
      class: _normalizeClass(["dropdown-button__button", customClass.value]),
      disabled: props.disabled,
      onClick: toggleDropdown
    }, [
      _renderSlot(_ctx.$slots, "label"),
      (displayDropdown.value)
        ? (_openBlock(), _createBlock(Mdi, {
            key: 0,
            icon: "expand_less"
          }))
        : (_openBlock(), _createBlock(Mdi, {
            key: 1,
            icon: "expand_more"
          }))
    ], 10, _hoisted_1),
    (displayDropdown.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
            return (_openBlock(), _createElementBlock("button", {
              key: option.value,
              disabled: option.disabled,
              class: "dropdown-button__option",
              onClick: ($event: any) => (onClickOptions(option.value))
            }, _toDisplayString(_unref(t)(option.label)), 9, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})